import Vue from 'vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import CryptoJs from 'crypto-js'
import encHex from 'crypto-js/enc-hex'

/**
 * 浏览器指纹
 */
export async function getBrowserFingerprint() {
  // 初始化FingerprintJS
  const fp = await FingerprintJS.load()
  // 获取访问者的指纹
  const result = await fp.get()
  const {
    plugins,
    ...components
  } = result.components
  const extendedComponents = {
    ...components
  }
  // const deviceInfo = JSON.stringify(extendedComponents)
  const fingerprintId = FingerprintJS.hashComponents(extendedComponents)
  Vue.$cookies.set('fp', fingerprintId, -1)
}

export function hashFile(file) {
  /**
   * 使用指定的算法计算hash值
   */
  function hashFileInternal(file, alog) {
    // 指定块的大小，这里设置为10MB,可以根据实际情况进行配置
    const chunkSize = 10 * 1024 * 1024
    let promise = Promise.resolve()
    // 使用promise来串联hash计算的顺序。因为FileReader是在事件中处理文件内容的，必须要通过某种机制来保证update的顺序是文件正确的顺序
    for (let index = 0; index < file.size; index += chunkSize) {
      promise = promise.then(() => hashBlob(file.slice(index, index + chunkSize)))
    }

    /**
     * 更新文件块的hash值
     */
    function hashBlob(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = ({ target }) => {
          const wordArray = CryptoJs.lib.WordArray.create(target.result)
          // 增量更新计算结果
          alog.update(wordArray)
          resolve()
        }
        reader.readAsArrayBuffer(blob)
      })
    }

    // 使用promise返回最终的计算结果
    return promise.then(() => encHex.stringify(alog.finalize()))
  }

  // 同时计算文件的sha256和md5,并使用promise返回
  /* return Promise.all([hashFileInternal(file, CryptoJs.algo.SHA256.create()),
    hashFileInternal(file, CryptoJs.algo.MD5.create())])
    .then(([sha256sum, md5sum]) => ({
      sha256sum,
      md5sum
    }))*/
  return Promise.all([hashFileInternal(file, CryptoJs.algo.SHA256.create()),
    hashFileInternal(file, CryptoJs.algo.MD5.create())])
    .then(([sha256sum]) => ({
      sha256sum
    }))
}

/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  const date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + '-'
  const M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
  const D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  const h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
  const s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  const date = new Date()
  date.setDate(date.getDate() + day)
  document.cookie = name + '=' + value + ';expires=' + date
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  const reg = RegExp(name + '=([^;]+)')
  const arr = document.cookie.match(reg)
  if (arr) {
    return arr[1]
  } else {
    return ''
  }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1)
}

const validFormAndInvoke = (formEl, success, message = '信息有误', fail = function() {
}) => {
  if (!formEl) {
    return
  }
  formEl.validate(valid => {
    if (valid) { // form valid succeed
      // do success function
      success()
      // reset fields
      formEl.resetFields()
    } else { // form valid fail
      Vue.prototype.$notify({
        title: 'Tips',
        message: message,
        type: 'error',
        duration: 2000
      })
      // do something when fail
      fail()
      return false
    }
  })
}

/**
 * 导出
 **/
export {
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  validFormAndInvoke
}
